module.exports = __webpack_public_path__ + "img/cooperate.0135f6f3.png";